








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Icon extends Vue
{
	@Prop() name!: string;
	@Prop() size!: string;
}
